export default "__VITE_PUBLIC_ASSET__8fdb0a56__"